import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=76389fdd&scoped=true&"
import script from "./AIAssistant.vue?vue&type=script&lang=js&"
export * from "./AIAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=76389fdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76389fdd",
  null
  
)

export default component.exports